export default __webpack_public_path__ + "components/wind-icon/static/E@2x-bbd16fc23c222803e5a10091e9234c24.png";